import { useIntl } from 'react-intl';
import React from 'react';
import { messages } from '../../../i18n/messages';
import { insertLinkIntoMessage } from '../../../util';
import styles from './RefundDisplay.module.scss';

export const RefundDisplay = (props: { helpCenterLanguage: string }) => {
    const { helpCenterLanguage } = props;
    const intl = useIntl();
    const refundUrl = `/help/${helpCenterLanguage}/articles/721549/can-i-get-a-refund/`;
    const linkText = intl.formatMessage(messages['here']);
    const linkTitle = intl.formatMessage({
        id: 'Link to Requesting a Refund',
        defaultMessage: 'Link to Requesting a Refund',
    });
    const link = (
        <a
            href={refundUrl}
            rel="noopener noreferrer"
            target="_blank"
            title={linkTitle}
        >
            {linkText}
        </a>
    );
    const message = intl.formatMessage(
        {
            id: 'Would like to request a refund? Learn more about how to request a refund {link}',
            defaultMessage: 'Would like to request a refund? Learn more about how to request a refund {link}',
        },
        {
            link: linkText,
        }
    );

    return (
        <p className={styles.refundText} data-testid="reason_refund-radio">
            {insertLinkIntoMessage(message, linkText, link)}.
        </p>
    );
};
